import { apiInstances } from '../../../libs';

const { get } = apiInstances.userInstance;

export default function getPaymentClouderServices() {
  return get(`/clouders/payment-services`);
}
